import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor() {}

  getInitialLang(): string {
    const regex = /(^| )translocoLang=([^;]+)/;
    const match = regex.exec(document.cookie);
    const cookieLang = match ? match[2] : null;
    return cookieLang ?? 'it';
  }
}
